import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Select from '../../../components/Select';
import DatePicker from '../../../components/DatePicker';
import 'parsleyjs';
import { Toastr } from '../../../components/Toastr/index';
import MaskedInput from 'react-text-mask';

class ClassForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transferAgents: [],
            transferAgent: '',
            transferAgentCode: '',
            transferAgentCodeSelected: ''
        };
    }

    componentDidMount() {
        let { classData } = this.props;
        this.setState({ transferAgents: classData.transferAgents });
    }

    handleInputChange = event => {
        let { classData, updateClassData, isEditable } = this.props;
        if (isEditable) {
            const target = event.target;
            const value =
                target.type === 'checkbox' ? target.checked : target.value;
            const name = target.name;
            let tmpSelected = _.extend({}, classData);
            tmpSelected[name] = value;
            updateClassData(tmpSelected);
        }
    };

    handleTAInputChange = event => {
        let { isEditable } = this.props;
        if (isEditable) {
            const target = event.target;
            const value = target.value;
            const name = target.name;
            this.setState({
                [name]: value
            });
        }
    };

    handleSelectChange = (name, value, valueKey) => {
        let { classData, updateClassData } = this.props;
        let tmpSelected = _.extend({}, classData);
        if (value !== null) {
            if (valueKey) {
                tmpSelected[name] = value[valueKey];
            } else {
                tmpSelected[name] = value[name];
            }
        } else {
            tmpSelected[name] = '';
        }
        updateClassData(tmpSelected);
    };

    handleTASelectChange = (name, value) => {
        let taCodeSelected = {};
        if (value !== null) {
            taCodeSelected = value[name];
        } else {
            taCodeSelected = '';
        }
        this.setState({ transferAgentCodeSelected: taCodeSelected });
    };

    handleDateChange = (name, value) => {
        let { classData, updateClassData } = this.props;
        let tmpSelected = _.extend({}, classData);
        if (value !== null) {
            tmpSelected[name] = value;
        } else {
            tmpSelected[name] = '';
        }
        updateClassData(tmpSelected);
    };

    onAddTAClick = () => {
        let { classData, updateClassData } = this.props;
        if (this.state.transferAgent && this.state.transferAgentCode) {
            let tmpSelected = _.extend({}, classData);
            if (!isNaN(this.state.transferAgentCode)) {
                tmpSelected['transferAgents'].push({
                    transferAgent: this.state.transferAgent,
                    transferAgentCode: parseInt(
                        this.state.transferAgentCode,
                        10
                    )
                });
                tmpSelected['transferAgentsJson'] = JSON.stringify(
                    tmpSelected['transferAgents']
                );

                updateClassData(tmpSelected);

                this.setState({
                    transferAgent: '',
                    transferAgentCode: ''
                });

                Toastr.info('Transfer agent added');
            } else {
                Toastr.error('Only numbers allowed for transfer agent code', {
                    showDuration: 100
                });
            }
        }
    };

    onRemoveTAClick = () => {
        let { classData, updateClassData } = this.props;
        if (this.state.transferAgentCodeSelected) {
            let tmpSelected = _.extend({}, classData);
            tmpSelected['transferAgents'] = classData.transferAgents.filter(
                ta =>
                    ta.transferAgentCode !==
                    this.state.transferAgentCodeSelected
            );
            tmpSelected['transferAgentsJson'] = JSON.stringify(
                tmpSelected['transferAgents']
            );
            updateClassData(tmpSelected);
            this.setState({
                transferAgentCodeSelected: ''
            });
            Toastr.info('Transfer agent removed from the list');
        }
    };

    handleMaskedInputChange = event => {
        let { classData, updateClassData, isEditable } = this.props;
        if (isEditable) {
            const target = event.target;
            const value =
                target.value === ''
                    ? target.value
                    : parseInt(target.value.replace(/[-]/g, ''), 10);
            const name = target.name;
            let tmpSelected = _.extend({}, classData);
            tmpSelected[name] = value;
            updateClassData(tmpSelected);
        }
    };

    render() {
        let { classData, parentPortfolios, isEditable, formRef } = this.props;
        return (
            <form ref={formRef}>
                {parentPortfolios && (
                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>*Portfolio</label>
                            <Select
                                clearable={false}
                                labelKey="name"
                                valueKey="portfolioId"
                                name="portfolioId"
                                selectedValue={classData.portfolioId}
                                onChange={this.handleSelectChange}
                                options={parentPortfolios}
                                disabled={!isEditable}
                                required={true}
                            />
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Edgar Class Id</label>
                        <input
                            className="form-control"
                            type="text"
                            name="edgarClassId"
                            value={classData.edgarClassId}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>*Name</label>
                        <input
                            className="form-control"
                            type="text"
                            name="name"
                            value={classData.name}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-required
                            data-parsley-maxlength="200"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>*Cusip</label>
                        <input
                            className="form-control"
                            type="text"
                            name="cusip"
                            value={classData.cusip}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-required
                            data-parsley-maxlength="9"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Formerly Known As Names</label>
                        <input
                            className="form-control"
                            type="text"
                            name="formerlyKnownAsNames"
                            value={classData.formerlyKnownAsNames}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="4000"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Ticker Symbol</label>
                        <input
                            className="form-control"
                            type="text"
                            name="tickerSymbol"
                            value={classData.tickerSymbol}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="5"
                        />
                    </div>
                </div>

                {/*Manage Transfer Agents Section*/}
                <div className="row">
                    <div className="form-group col-md-12 mb0">
                        <label>Transfer Agents</label>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12 mb0">
                        <div className="form-group col-md-6 pl0">
                            <input
                                className="form-control"
                                type="text"
                                name="transferAgent"
                                placeholder="Name"
                                value={this.state.transferAgent}
                                onChange={this.handleTAInputChange}
                                disabled={!isEditable}
                                data-parsley-maxlength="5"
                            />
                        </div>
                        <div className="form-group col-md-5 pl0 pr0">
                            <input
                                className="form-control"
                                type="text"
                                name="transferAgentCode"
                                placeholder="Code"
                                value={this.state.transferAgentCode}
                                onChange={this.handleTAInputChange}
                                disabled={!isEditable}
                                data-parsley-type="number"
                                data-parsley-maxlength="5"
                            />
                        </div>
                        <div className="form-group col-md-1">
                            <button
                                type="button"
                                className="btn btn-default btn-bordered btn-sm"
                                onClick={this.onAddTAClick}
                                disabled={!isEditable}
                            >
                                <span className="glyphicon glyphicon-plus" />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12 mb0">
                        <div className="form-group col-md-11 pl0 pr0">
                            <Select
                                labelKey="transferAgent"
                                valueKey="transferAgentCode"
                                name="transferAgentCode"
                                selectedValue={
                                    this.state.transferAgentCodeSelected
                                }
                                onChange={this.handleTASelectChange}
                                options={classData.transferAgents}
                            />
                        </div>
                        <div className="form-group col-md-1">
                            <button
                                type="button"
                                className="btn btn-default btn-bordered btn-sm"
                                onClick={this.onRemoveTAClick}
                                disabled={!isEditable}
                            >
                                <span className="glyphicon glyphicon-minus" />
                            </button>
                        </div>
                    </div>
                </div>
                {/*Manage Transfer Agents Section Finished*/}

                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Fund Group</label>
                        <input
                            className="form-control"
                            type="text"
                            name="fundGroup"
                            value={classData.fundGroup}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="10"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Client Code</label>
                        <input
                            className="form-control"
                            type="text"
                            name="clientCode"
                            value={classData.clientCode}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="10"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Sec Effective Date</label>
                        <DatePicker
                            name="secEffectiveDate"
                            value={classData.secEffectiveDate}
                            onChange={this.handleDateChange}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>*Fiscal Year End</label>
                        <DatePicker
                            name="fiscalYearEnd"
                            value={classData.fiscalYearEnd}
                            onChange={this.handleDateChange}
                            disabled={!isEditable}
                            required={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Is Shares Of Beneficial Interest</label>
                        <Select
                            labelKey="name"
                            valueKey="isSharesOfBeneficialInterest"
                            name="isSharesOfBeneficialInterest"
                            selectedValue={
                                classData.isSharesOfBeneficialInterest
                            }
                            onChange={this.handleSelectChange}
                            options={[
                                {
                                    name: 'Yes',
                                    isSharesOfBeneficialInterest: true
                                },
                                {
                                    name: 'No',
                                    isSharesOfBeneficialInterest: false
                                }
                            ]}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Min Initial Purchase</label>
                        <input
                            className="form-control"
                            type="text"
                            name="minInitialPurchase"
                            value={classData.minInitialPurchase}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Min Subsequent Purchase</label>
                        <input
                            className="form-control"
                            type="text"
                            name="minSubsequentPurchase"
                            value={classData.minSubsequentPurchase}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Retirement Min Purchase</label>
                        <input
                            className="form-control"
                            type="text"
                            name="retirementMinPurchase"
                            value={classData.retirementMinPurchase}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Retirement Subsequent Purchase</label>
                        <input
                            className="form-control"
                            type="text"
                            name="retirementSubsequentPurchase"
                            value={classData.retirementSubsequentPurchase}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Federal ID</label>
                        <MaskedInput
                            id="classFederalId"
                            mask={[
                                /\d/,
                                /\d/,
                                '-',
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/
                            ]}
                            className="form-control"
                            type="text"
                            name="federalId"
                            value={
                                classData.federalId === 0
                                    ? ''
                                    : classData.federalId
                            }
                            onChange={this.handleMaskedInputChange}
                            disabled={!isEditable}
                        />
                        {/*Following hidden input is added for parsley validation*/}
                        <input
                            type="text"
                            style={{ display: 'none' }}
                            value={
                                classData.federalId === 0
                                    ? ''
                                    : classData.federalId
                            }
                            readOnly
                            data-parsley-length="[9,9]"
                            data-parsley-error-message="This value length is invalid. It should be 9 characters long."
                            data-parsley-class-handler={'#classFederalId'}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Conversion Date</label>
                        <DatePicker
                            name="conversionDate"
                            value={classData.conversionDate}
                            onChange={this.handleDateChange}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Launch Date</label>
                        <DatePicker
                            name="launchDate"
                            value={classData.launchDate}
                            onChange={this.handleDateChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

ClassForm.propTypes = {
    classData: PropTypes.object.isRequired,
    parentPortfolios: PropTypes.array,
    updateClassData: PropTypes.func,
    isEditable: PropTypes.func.bool
};

ClassForm.defaultProps = {
    isEditable: true
};

export default ClassForm;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/components/ClassForm.js